import { ShieldCheck, ArrowRight, ExternalLink } from "lucide-react";
import EligibilityForm from "./EligibilityForm";

export default function Hero() {
  return (
    <section id="hero" className="relative overflow-hidden glow-bg">
      <div className="mx-auto max-w-6xl px-5 lg:px-8 pt-12 sm:pt-16 lg:pt-20 pb-20 lg:pb-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* LEFT */}
          <div className="lg:col-span-7 lg:pt-2">
            {/* Pastille FIPU : hauteur auto (pas h-7) pour que le texte ne soit pas tronqué sur mobile */}
            <div
              className="flex items-center gap-2.5 sm:gap-3 w-full min-w-0"
              data-testid="hero-badge"
            >
              <span className="tricolor-stripe shrink-0" aria-hidden />
              <div className="inline-flex min-w-0 flex-1 items-center gap-2 rounded-full border pc-line bg-white px-3 py-2 sm:px-3.5 sm:py-1.5 text-left text-[11.5px] sm:text-[12.5px] font-medium leading-snug pc-text-ink">
                <ShieldCheck
                  className="w-3.5 h-3.5 shrink-0 self-center pc-text-blue"
                  strokeWidth={2.4}
                  aria-hidden
                />
                <span className="min-w-0">
                  Dispositif officiel <span className="font-mono-num">FIPU</span> — géré par la{" "}
                  <span className="font-mono-num">CARSAT</span>
                </span>
              </div>
            </div>

            <h1
              className="display-1 pc-text-ink mt-7 text-balance"
              data-testid="hero-h1"
            >
              Touchez jusqu'à <span className="font-serif-num pc-text-blue font-semibold">75&nbsp;000&nbsp;€</span> de subventions <span className="font-serif-emph">d'État</span>.
            </h1>

            <p
              className="mt-7 text-[19px] sm:text-[20.5px] leading-[1.5] max-w-2xl text-pretty font-normal"
              style={{ color: 'var(--pc-ink-soft)' }}
              data-testid="hero-subtitle"
            >
              Nous montons vos dossiers <span className="pc-text-ink font-medium">CARSAT</span> et suivons chaque étape
              jusqu’au versement. Vous ne payez qu'une fois <span className="pc-text-ink font-medium">l'argent sur votre compte</span>.
            </p>

            {/* Legal anchor */}
            <p className="mt-6 text-[13px] pc-text-muted leading-[1.55] max-w-xl" data-testid="hero-legal">
              Art. <span className="font-mono-num">L.&nbsp;221-1-2</span> du Code de la Sécurité sociale — loi <span className="font-mono-num">n°&nbsp;2023-270</span> du 14 avril 2023.{" "}
              <a
                href="https://www.ameli.fr/entreprise/sante-travail/prevention/aides-financieres"
                target="_blank" rel="noreferrer noopener"
                className="pc-text-blue hover:underline inline-flex items-center gap-1 font-medium"
              >
                Vérifiable sur ameli.fr <ExternalLink className="w-3 h-3" />
              </a>
            </p>

            <div className="mt-9 flex flex-col sm:flex-row sm:items-center gap-3">
              <a
                href="#form-final"
                className="btn-primary inline-flex items-center justify-center gap-2"
                data-testid="hero-cta-primary"
              >
                Vérifier mon éligibilité
                <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href="#methode"
                className="btn-link-blue inline-flex items-center gap-1.5 px-2 py-2"
                data-testid="hero-cta-secondary"
              >
                Voir la méthode
                <ArrowRight className="w-3.5 h-3.5" />
              </a>
            </div>

            {/* Trust strip with hairline separators */}
            <div className="mt-14 grid grid-cols-3 max-w-xl">
              <TrustStat value="0 €" label="à avancer" first />
              <TrustStat value="24h" label="rappel garanti" />
              <TrustStat value="100%" label="dossier géré" />
            </div>
          </div>

          {/* RIGHT — Form */}
          <div className="lg:col-span-5 lg:sticky lg:top-24" id="form-hero">
            <EligibilityForm sourceSection="hero" testIdPrefix="form-hero" />
          </div>
        </div>
      </div>
    </section>
  );
}

function TrustStat({ value, label, first }) {
  return (
    <div className={`px-4 sm:px-5 ${first ? "pl-0" : "border-l"}`} style={{ borderColor: first ? undefined : "var(--pc-line-strong)" }}>
      <div className="text-[28px] sm:text-[32px] pc-text-ink font-serif-num leading-none font-semibold tracking-[-0.02em]">
        {value}
      </div>
      <div className="text-[12.5px] pc-text-muted mt-2">{label}</div>
    </div>
  );
}
